
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deposits",
      function () {
        return require("private-next-pages/deposits/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deposits"])
      });
    }
  